import script from "./edit-subnet-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./edit-subnet-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./edit-subnet-drawer.vue?vue&type=style&index=0&id=d2e87da8&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2e87da8"]])

export default __exports__